import { Formik, Field, Form } from 'formik';
import { TableFilterType, useTableFilterQuery, useTableFilterMutation } from './TableFilter.hooks';
import { useCallback } from 'react';
import classNames from 'classnames';
import { AutoSubmit } from '../AutoSubmit';

type TableFilterFormikProps = {
  className?: string;
}

export const TableFilterFormik = ({ className }: TableFilterFormikProps) => {
  const { data: initialValues, isSuccess } = useTableFilterQuery();
  const { mutate } = useTableFilterMutation();
  const onSubmit = useCallback(
    (data: TableFilterType) => {
      mutate(data);
    },
    [mutate],
  );

  return (isSuccess ? (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      <Form className={classNames("d-flex justify-content-end", className)}>
        <div role="group" aria-labelledby="checkbox-group">
          <div className="form-check form-check-inline">
            <Field id="trailing-pe" className="form-check-input" type="radio" name="fields" value="trailing-pe" />
            <label className="form-check-label" htmlFor="trailing-pe">
              PER
            </label>
          </div>
          <div className="form-check form-check-inline">
            <Field id="forward-pe" className="form-check-input" type="radio" name="fields" value="forward-pe" />
            <label className="form-check-label" htmlFor="forward-pe">
              추정 PER
            </label>
          </div>
          <div className="form-check form-check-inline me-0">
            <Field id="decline-rate" className="form-check-input" type="radio" name="fields" value="decline-rate" />
            <label className="form-check-label" htmlFor="decline-rate">
              고점 대비 하락률
            </label>
          </div>
        </div>
        <AutoSubmit />
      </Form>
    </Formik>
  ) : null);
}
